import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTranscriptionWrongCallDuration = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 411,
	height: 303,
	viewBox: "0 0 411 303",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_11327_274823",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 101,
			y: 50,
			width: 200,
			height: 200,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M301 50H101V250H301V50Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_11327_274823)",
			children: /* @__PURE__ */ _jsx("g", {
				opacity: .2,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M263.409 186.79C269.518 192.899 269.095 203.116 261.754 207.672C232.18 226.03 210.394 216.287 172.553 178.443C134.713 140.6 124.971 118.811 143.327 89.2346C147.883 81.8939 158.099 81.4707 164.207 87.5799L182.867 106.241C188.563 111.938 188.083 120.858 183.721 127.631C177.224 137.719 180.377 145.01 193.181 157.814C205.984 170.619 213.274 173.772 223.361 167.274C230.134 162.912 239.053 162.432 244.749 168.129L263.409 186.79Z",
					fill: "#00BD82"
				})
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_11327_274823)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M117.673 132.807C112.671 114.136 93.4787 103.055 74.8074 108.058C56.1361 113.061 45.0557 132.253 50.0587 150.924C55.0616 169.596 74.2534 180.676 92.9247 175.673C111.596 170.67 122.676 151.478 117.673 132.807Z",
					fill: "url(#paint0_linear_11327_274823)",
					fillOpacity: .6
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M117.19 132.937C112.259 114.532 93.3413 103.61 74.9367 108.542C56.5322 113.473 45.6101 132.391 50.5416 150.795C55.4731 169.2 74.3907 180.122 92.7953 175.191C111.2 170.259 122.122 151.341 117.19 132.937Z",
					stroke: "url(#paint1_linear_11327_274823)",
					strokeOpacity: .5
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask1_11327_274823",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 58,
					y: 116,
					width: 52,
					height: 52,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M98.7154 116.147L58.1465 127.017L69.0169 167.586L109.586 156.715L98.7154 116.147Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsxs("g", {
					mask: "url(#mask1_11327_274823)",
					children: [/* @__PURE__ */ _jsx("path", {
						opacity: .5,
						d: "M97.5061 149.741C99.5215 146.25 100.205 141.991 99.0795 137.79C96.8282 129.388 88.1919 124.401 79.7898 126.653C71.3877 128.904 66.4015 137.54 68.6529 145.942C69.7785 150.143 72.5004 153.491 75.9912 155.506L77.7412 152.475C75.0262 150.907 72.9091 148.304 72.0336 145.037C70.2826 138.502 74.1607 131.784 80.6957 130.033C87.2306 128.282 93.9477 132.161 95.6988 138.695C96.5743 141.963 96.0425 145.276 94.475 147.991L97.5061 149.741Z",
						fill: "#00BD82"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M86.8978 140.115C87.0473 140.375 87.1657 140.657 87.2469 140.96C87.7472 142.827 86.6391 144.746 84.772 145.247C82.9049 145.747 80.9857 144.639 80.4854 142.772C79.9851 140.905 81.0931 138.986 82.9603 138.485C83.2632 138.404 83.5674 138.365 83.8668 138.365L91.1007 125.836C91.584 124.999 92.6543 124.712 93.4913 125.195C94.3283 125.678 94.6151 126.749 94.1318 127.586L86.8978 140.115Z",
						fill: "#00BD82"
					})]
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_d_11327_274823)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M306.72 55.9778C302.432 39.9738 285.982 30.4763 269.978 34.7646C253.974 39.0529 244.476 55.503 248.765 71.5069C253.053 87.5109 269.503 97.0084 285.507 92.7201C301.511 88.4319 311.008 71.9818 306.72 55.9778Z",
					fill: "url(#paint2_linear_11327_274823)",
					fillOpacity: .6
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M306.237 56.1072C302.02 40.3699 285.844 31.0307 270.107 35.2475C254.37 39.4643 245.031 55.6402 249.247 71.3775C253.464 87.1147 269.64 96.4539 285.377 92.2371C301.115 88.0204 310.454 71.8444 306.237 56.1072Z",
					stroke: "url(#paint3_linear_11327_274823)",
					strokeOpacity: .5
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask2_11327_274823",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 255,
					y: 41,
					width: 45,
					height: 45,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M290.471 41.6969L255.697 51.0144L265.015 85.7877L299.788 76.4702L290.471 41.6969Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsxs("g", {
					mask: "url(#mask2_11327_274823)",
					children: [/* @__PURE__ */ _jsx("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M287.292 47.4197C286.501 46.9631 285.517 47.0201 284.794 47.5796C282.693 49.2073 278.31 52.6998 275.716 55.4586C274.748 56.488 273.729 57.7338 272.761 58.9981L263.811 61.8591C263.191 62.0574 263.101 62.8977 263.664 63.2232L269.341 66.5004C270.058 66.9146 270.257 67.8513 270.238 68.6795C270.214 69.7401 270.755 70.7807 271.738 71.3485L274.336 72.8485C275.319 73.4163 276.491 73.3639 277.397 72.8128C278.105 72.3824 279.016 72.0862 279.733 72.5004L285.409 75.7777C285.973 76.1032 286.656 75.6051 286.518 74.9687L284.514 65.758C285.008 64.5719 285.476 63.3685 285.852 62.2505C285.943 61.9809 286.028 61.7167 286.108 61.4586C287.255 57.7276 288.061 52.2498 288.403 49.6462C288.52 48.7463 288.078 47.8735 287.292 47.4197ZM280.705 59.2051C282.14 60.0335 283.974 59.5419 284.803 58.107C285.631 56.6721 285.14 54.8373 283.705 54.0089C282.27 53.1805 280.435 53.6721 279.607 55.107C278.778 56.5419 279.27 58.3766 280.705 59.2051Z",
						fill: "#00BD82"
					}), /* @__PURE__ */ _jsx("path", {
						opacity: .5,
						d: "M270.132 72.1531L274.778 74.8352C274.778 74.8352 274.455 76.8242 273.278 77.4333C271.702 78.2482 269.455 78.6903 269.455 78.6903C269.455 78.6903 268.714 76.5232 268.632 74.7512C268.571 73.4268 270.132 72.1531 270.132 72.1531Z",
						fill: "#00BD82"
					})]
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_d_11327_274823)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M361.507 200.9C367.084 179.525 354.277 157.675 332.901 152.098C311.525 146.521 289.675 159.329 284.098 180.704C278.521 202.08 291.329 223.93 312.705 229.507C334.081 235.084 355.93 222.276 361.507 200.9Z",
					fill: "url(#paint4_linear_11327_274823)",
					fillOpacity: .6
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M361.023 200.774C366.53 179.665 353.883 158.089 332.774 152.582C311.666 147.074 290.089 159.722 284.582 180.831C279.075 201.939 291.722 223.516 312.831 229.023C333.939 234.53 355.516 221.883 361.023 200.774Z",
					stroke: "url(#paint5_linear_11327_274823)",
					strokeOpacity: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M326.996 178.95C327.756 177.045 325.498 175.367 323.893 176.644L309.441 188.143C308.151 189.169 308.586 191.227 310.181 191.643L321.792 194.673L318.608 202.654C317.849 204.559 320.106 206.237 321.711 204.96L336.164 193.461C337.453 192.435 337.018 190.377 335.423 189.961L323.812 186.932L326.996 178.95Z",
					fill: "#00BD82"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_11327_274823",
				x: .857422,
				y: 82.8571,
				width: 166.018,
				height: 166.018,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 24 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 24 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_11327_274823"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_11327_274823",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_11327_274823",
				x: 199.734,
				y: 9.73486,
				width: 156.016,
				height: 156.015,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 24 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 24 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_11327_274823"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_11327_274823",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_11327_274823",
				x: 234.793,
				y: 126.793,
				width: 176.02,
				height: 176.02,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 24 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 24 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_11327_274823"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_11327_274823",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_11327_274823",
				x1: 74.8074,
				y1: 108.058,
				x2: 92.9247,
				y2: 175.673,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#C9C9C9",
					stopOpacity: .5
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EAEBF0",
					stopOpacity: .5
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_11327_274823",
				x1: 74.7366,
				y1: 108.229,
				x2: 92.8539,
				y2: 175.844,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CACCD8" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6B6C72",
					stopOpacity: .25
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_11327_274823",
				x1: 269.978,
				y1: 34.7646,
				x2: 285.507,
				y2: 92.72,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#C9C9C9",
					stopOpacity: .5
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EAEBF0",
					stopOpacity: .5
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_11327_274823",
				x1: 269.907,
				y1: 34.9351,
				x2: 285.437,
				y2: 92.8904,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CACCD8" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6B6C72",
					stopOpacity: .25
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_11327_274823",
				x1: 332.901,
				y1: 152.098,
				x2: 312.705,
				y2: 229.507,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#C9C9C9",
					stopOpacity: .5
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EAEBF0",
					stopOpacity: .5
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_11327_274823",
				x1: 333.066,
				y1: 152.027,
				x2: 312.87,
				y2: 229.436,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CACCD8" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6B6C72",
					stopOpacity: .25
				})]
			})
		] })
	]
});
export default SvgTranscriptionWrongCallDuration;
